// 2026-05-26 - FormuLearning - Step 3 §3.4 대조약 실험 결과 (용출 프로파일)
// 2026-07-18 - 다중 lot 확장 (이슈 #40). lot 탭으로 여러 lot을 관리하고, 선택한 lot이 "진행 중"(active_lot).
// 2026-07-23 - 이슈 #50(P1): 위치기반 배열 왕복 폐기 → Lot DB id 대면 + 전용 Lot API 전환.
//              탭 라벨 "Lot N · MM/DD"(BR-LOT-12) · 삭제=숨기기(BR-LOT-11) · 격자 잠금 배너(BR-LOT-10)
//              · 대조약 저장 = saveReference(BR-S3-L02). 시각 정본 = lot_ui_prototype.html.
// 2026-07-23 수정 - P1 검증 피드백: 잠금은 격자(시점·용액)만 — 값(avg·SD)·측정일 편집 허용(F-7),
//              Step 4 선택기와 활성 Lot 동기화(useLotSync, F-8), RLD→Reference Drug 용어(F-1·5·6).
// 2026-08-31 수정 - 이슈 #58 S5 3차(#68, M84-16): **0 시점 행을 표에서 숨긴다.** 입력이
//              불요하고(양쪽 0%) f2 계산에서도 제외되는데(ADR-0005) 표에만 남아 오해를 샀다.
//              그래프에는 그대로 나온다. 숨김이라 추가·삭제도 자연히 막힌다.
//              같은 이유로 `+ Time Point` 의 기본 시점을 **0 → 마지막+15분**으로 바꾼다 —
//              0 으로 붙이면 추가한 행이 곧바로 보이지 않는 상태가 된다.
// 2026-08-14 수정 - 이슈 #60(M84-17): 용액 열·시점 행 **삭제** 추가. BR-S3-05·REQ-FN-3-04가
//              "pH 추가·삭제 가능"을 이미 규정하는데 추가만 있던 결함. 삭제도 격자 조작이므로
//              BR-LOT-10 잠금을 그대로 타고, 최소 1개는 남긴다.
// 2026-08-14 수정 - 이슈 #60(M84-18): 탭 라벨을 `Lot N` 고정에서 사용자 입력 표기(label)
//              대체로. 입력받아 저장만 하고 쓰지 않던 결함. lotDisplayName() 공통 규칙.
// 2026-08-31 수정 - 이슈 #58 S5 5차(#68, M84-72 확대): **붙여넣기 grid 3곳째.** 4차는
//              정본이 지목한 2곳(`COMP-DISSOLUTION-GRID`·`COMP-TEST-RESULT-PANEL`)에만
//              얹었는데, 대조약 표가 값을 가장 많이 받는 자리인데도 빠져 있었다.
//              용출 그리드와 **똑같은 규약**이다 — 시점 열은 붙여넣기 대상이 아니고
//              (격자 정본 = Lot, BR-LOT-09·10) 동반 복사분은 `dropIndexColumn` 이 걷는다.
//              시점 열이 여기서는 편집 가능이라 "보정이 열을 조용히 버린다"가 쟁점이었으나
//              *"사용자가 알아서 할 일"* 로 현행 동작 유지 확정(260831).
// 2026-08-30 수정 - 이슈 #58 S1(#64): Pull 폐기(§13.7) — `↓ 데이터 가져오기` 버튼·
//              `LotPullDialog` 제거. **`⊘` 제외 토글** 신설(BR-LOT-14) — 숨기기(`✕`)와
//              별개 축이며(BR-LOT-15) 제외 Lot 은 탭에 흐림 + `제외` 배지로 남는다.
//              시각 정본 = UI/UX v2.2 §5.8 `COMP-LOT-TABS`.
// 2026-09-22 수정 - 이슈 #67 S4-2: Lot 조작(대조약 저장·활성 전환·생성·숨김)이 성공하면
//              `onLotsSaved` 로 알린다 — 서버가 Y 파생 행을 다시 만들었으므로(BR-RND-05) 카드가
//              Y 를 다시 읽는다. 격자 잠금 표시·범례 정리는 #75(`M901-17`) 몫이라 두었다.
// 2026-09-24 수정 - 이슈 #75(G4): **`⊘` Lot 제외 폐지**(`M901-18` — 숨기기만 남는다) ·
//              **격자 잠금 잔재 제거**(`M901-17` — 상태 점·범례·배너·버튼 비활성·409 처리).
//              격자·값·측정일은 언제나 편집한다(BR-LOT-10 v1.14).
//              대조약 프로파일 저장도 Step 3 «사용자 저장» 이라 첫 저장 전에 주성분 확정을 묻는다
//              (`beforeSave`, `M915-04`·BR-STEP-03). 거절하면 편집은 미저장으로 두고, 확정되면 마저 저장한다.
// 2026-11-03 수정 - 이슈 #114: viewer(조회 전용) — Lot 탭 클릭은 서버 호출 없이 화면 안에서만 전환(장지연 교수 261103 D1=B),
//              숨기기·New Lot·편집 영역(fieldset)은 비활성 + «조회 전용 계정».
// 파일 위치: frontend/src/features/step3/RldExperimentSection.tsx

import React, { useEffect, useMemo, useRef, useState } from 'react'
import type { ClipboardEvent } from 'react'
import type { RLDExperiment, RLDLot, PhProfile, DissolutionTimePoint } from '../../api/step3'
import { getStep3, normalizeRldExperiment } from '../../api/step3'
import {
  createLot as apiCreateLot,
  setActiveLot as apiSetActiveLot,
  hideLot as apiHideLot,
  saveReference as apiSaveReference,
  conflictDetail,
  lotDisplayName,
} from '../../api/lot'
import { useLotSync } from '../../stores/lotStore'
import { useSubstanceSync } from '../../stores/substanceSyncStore'
import { useCanWrite, READ_ONLY_TITLE } from '../../hooks/useCanWrite'
import { isReadOnly } from '../../lib/readOnly'
import {
  applyMatrix, describePaste, dropIndexColumn, isRangePaste,
  parseClipboardMatrix, stripHeaderRows,
} from '../../lib/pasteGrid'

interface Props {
  projectId: string
  experiment: RLDExperiment
  /** 로컬 상태 동기화 전용 — 저장은 이 컴포넌트가 Lot API로 직접 수행한다(이슈 #50 P1). */
  onChange: (exp: RLDExperiment) => void
  /** Lot 조작 성공 알림(#67 S4-2) — 서버가 Y 파생 행을 다시 만들었으니 Y 를 다시 읽으라는 신호. */
  onLotsSaved?: () => void
  /** 서버 저장 직전 확인(#75 BR-STEP-03 주성분 확정). false 면 저장하지 않고 편집을 미저장으로 둔다. */
  beforeSave?: () => Promise<boolean>
}

type SaveState = 'idle' | 'saving' | 'saved' | 'error' | 'held'

/** "YYYY-MM-DD" → "MM/DD" (탭 라벨용, BR-LOT-12). 미입력이면 빈 문자열. */
const fmtMMDD = (isoDate: string): string =>
  /^\d{4}-\d{2}-\d{2}/.test(isoDate) ? `${isoDate.slice(5, 7)}/${isoDate.slice(8, 10)}` : ''

export default function RldExperimentSection({ projectId, experiment, onChange, onLotsSaved, beforeSave }: Props) {
  const [exp, setExp] = useState<RLDExperiment>(normalizeRldExperiment(experiment))
  const canWrite = useCanWrite()
  const [saveState, setSaveState] = useState<SaveState>('idle')
  // 붙여넣기 고지(M84-72) — 초과분을 버렸다는 사실을 알린다. 저장 시 지운다.
  const [pasteNote, setPasteNote] = useState<string | null>(null)
  // Step 4 선택기와의 활성 Lot 동기화(F-8) — 어느 쪽이 바꾸든 revision이 올라 양쪽이 재조회.
  const revision = useLotSync((s) => s.revision)
  const bumpLots = useLotSync((s) => s.bump)

  // 디바운스 저장 — 최신 편집본·in-flight 생성·타이머를 ref로 관리한다(닫힌 상태 참조 방지).
  const expRef = useRef(exp)
  const pendingRef = useRef<RLDLot | null>(null)
  const timerRef = useRef<number | null>(null)
  const createPromiseRef = useRef<Promise<{ id: string; lot_no: number }> | null>(null)
  const flushRef = useRef<() => Promise<void>>(async () => {})
  // 최신 콜백을 ref 로 — 언마운트 flush 등 닫힌 상태에서 불려도 지금의 콜백을 쓴다.
  const lotsSavedRef = useRef(onLotsSaved)
  useEffect(() => {
    lotsSavedRef.current = onLotsSaved
  }, [onLotsSaved])
  const notifyLotsSaved = () => lotsSavedRef.current?.()
  const refreshRef = useRef<() => Promise<void>>(async () => {})

  const commit = (next: RLDExperiment) => {
    expRef.current = next
    setExp(next)
    onChange(next)
  }

  const active = exp.active_lot
  const lot = exp.lots[active] ?? exp.lots[0]

  // ── 저장 (saveReference, BR-S3-L02) ──────────────────────────────────

  const flushSave = async () => {
    const snap = pendingRef.current
    if (!snap) return
    if (timerRef.current) {
      window.clearTimeout(timerRef.current)
      timerRef.current = null
    }
    if (beforeSave && !(await beforeSave())) {
      setSaveState('held') // 편집은 pendingRef 에 남는다 — 주성분이 확정되면 마저 저장한다(아래 효과)
      return
    }
    if (pendingRef.current !== snap) return // 확인하는 사이 새 편집이 들어왔다 — 그쪽 저장이 맡는다
    pendingRef.current = null
    if (timerRef.current) {
      window.clearTimeout(timerRef.current)
      timerRef.current = null
    }
    setSaveState('saving')
    try {
      let lotId = snap.id
      if (!lotId) {
        // DB에 Lot이 아직 없는 초기 상태 — 첫 저장 시 Lot을 만들어 id를 확보한다.
        // in-flight 생성을 공유해 연타로 Lot이 중복 생성되지 않게 한다.
        if (!createPromiseRef.current) createPromiseRef.current = apiCreateLot(projectId)
        const created = await createPromiseRef.current
        lotId = created.id
        const cur = expRef.current
        const idx = cur.lots.findIndex((l) => l.id === null)
        if (idx >= 0) {
          commit({
            ...cur,
            lots: cur.lots.map((l, i) => (i === idx ? { ...l, id: created.id, no: created.lot_no } : l)),
          })
        }
      }
      await apiSaveReference(projectId, lotId, snap.ph_profiles, snap.test_date || null, snap.lot_no || null)
      setSaveState('saved')
      notifyLotsSaved() // 활성 Lot 용출액이 바뀌었으면 Y 파생 행도 바뀌었다(BR-RND-05)
    } catch {
      setSaveState('error')
    }
  }
  flushRef.current = flushSave

  const schedulePersist = (l: RLDLot) => {
    pendingRef.current = l
    setSaveState('saving')
    if (timerRef.current) window.clearTimeout(timerRef.current)
    timerRef.current = window.setTimeout(() => void flushRef.current(), 600)
  }

  // 주성분이 확정되면(#75 BR-STEP-03) 보류해 둔 편집분을 저장한다.
  const substanceRevision = useSubstanceSync((s) => s.revision)
  useEffect(() => {
    if (substanceRevision > 0) void flushRef.current()
  }, [substanceRevision])

  // 언마운트 시 잔여 편집분을 마저 저장한다(fire-and-forget).
  useEffect(() => {
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current)
      void flushRef.current()
    }
  }, [])

  /** 서버 기준 재조립 — Lot 조작(생성·숨김·잠금 발견) 후 단일 진실 출처로 되돌린다. */
  const refresh = async () => {
    const d = await getStep3(projectId)
    commit(normalizeRldExperiment(d.rld_experiment))
  }
  refreshRef.current = refresh

  // Step 4 선택기 등 다른 곳에서 활성 Lot이 바뀌면 서버 기준으로 재조회한다(F-8).
  // 편집 중(pending·타이머)이면 입력 보호를 위해 생략 — 다음 조작 시 flush 후 정렬된다.
  const firstRevisionRef = useRef(true)
  useEffect(() => {
    if (firstRevisionRef.current) {
      firstRevisionRef.current = false
      return
    }
    if (pendingRef.current || timerRef.current) return
    void refreshRef.current()
  }, [revision])

  // ── Lot 조작 (전용 API, 프로세스 §13.10) ─────────────────────────────

  const selectLot = async (i: number) => {
    if (i === active) return
    setPasteNote(null) // 직전 Lot 의 붙여넣기 고지는 여기서 의미가 없다
    await flushSave()
    const next = { ...expRef.current, active_lot: i }
    commit(next)
    // viewer(#114 D1=B) — 보기만 바꾼다. 서버 활성 Lot 은 프로젝트 공용 상태이고 Y 파생·재분석을 부른다.
    if (isReadOnly()) return
    const target = next.lots[i]
    if (target?.id) {
      try {
        await apiSetActiveLot(projectId, target.id) // BR-LOT-08 활성 전환
        bumpLots() // Step 4 동기화(F-8)
        notifyLotsSaved() // Y 파생 기준이 바뀌었다(BR-RND-05)
      } catch {
        await refresh() // 실패 시 서버 기준 복원
      }
    }
  }

  const addLot = async () => {
    await flushSave()
    try {
      const created = await apiCreateLot(projectId) // 디폴트 격자는 백엔드가 부착(BR-LOT-09)
      await apiSetActiveLot(projectId, created.id)
      await refresh()
      bumpLots() // Step 4 동기화(F-8)
      notifyLotsSaved()
    } catch {
      window.alert('새 Lot 생성에 실패했습니다.')
    }
  }

  const removeLot = async (i: number) => {
    const cur = expRef.current
    const target = cur.lots[i]
    if (cur.lots.length <= 1 || !target?.id) return // 최소 1개 유지·미저장 lot 제외
    const name = lotDisplayName(target.lot_no, target.no ?? i + 1)
    if (!window.confirm(`${name}을(를) 숨기시겠습니까?\n데이터는 보존되며 목록에서만 사라집니다.`)) return
    await flushSave()
    try {
      await apiHideLot(projectId, target.id) // 소프트 삭제(BR-LOT-11)
      await refresh()
      bumpLots() // Step 4 동기화(F-8)
      notifyLotsSaved() // 활성 Lot 을 숨겼으면 Y 파생 기준이 옮겨 갔다
    } catch (e) {
      window.alert(conflictDetail(e) ?? 'Lot 숨기기에 실패했습니다.')
    }
  }

  // ── 활성 lot 편집 (로컬 patch + 디바운스 저장) ───────────────────────
  // 잠금(BR-LOT-10, 260723 완화)은 격자 조작에만 적용 — 값(avg·SD)·측정일·표기는 항상 편집 가능.

  const patchLot = (updater: (l: RLDLot) => RLDLot) => {
    const cur = expRef.current
    const nextLots = cur.lots.map((l, i) => (i === cur.active_lot ? updater(l) : l))
    commit({ ...cur, lots: nextLots })
    schedulePersist(nextLots[cur.active_lot])
  }

  const updateMeta = (field: 'lot_no' | 'test_date', val: string) =>
    patchLot((l) => ({ ...l, [field]: val }))

  const addPhColumn = () => {
    patchLot((l) => {
      const newPh: PhProfile = {
        ph: '',
        time_points: l.ph_profiles[0]?.time_points?.map((tp) => ({ time: tp.time, dissolution: 0, sd: 0 })) || [],
      }
      return { ...l, ph_profiles: [...l.ph_profiles, newPh] }
    })
  }

  // 2026-07-21 - 빈 lot(용액 열 0개)에서 누르면 map이 빈 배열을 돌아 **무반응**이었다.
  // 용액 열이 하나도 없으면 기본 열을 먼저 만들고 시점을 추가한다.
  const addTimePoint = () => {
    patchLot((l) => {
      const base = l.ph_profiles.length > 0
        ? l.ph_profiles
        : [{ ph: '', time_points: [] } as PhProfile]
      // 0분은 표에서 숨기므로(M84-16) 새 행을 0으로 붙이면 추가한 행이 보이지 않는다.
      // 마지막 시점 + 15분을 기본으로 세우고, 첫 행이면 15분으로 시작한다.
      const last = Math.max(0, ...(base[0]?.time_points || []).map((tp) => tp.time || 0))
      const next = last + 15
      return {
        ...l,
        ph_profiles: base.map((p) => ({
          ...p,
          time_points: [...(p.time_points || []), { time: next, dissolution: 0, sd: 0 }],
        })),
      }
    })
  }

  // 2026-08-14 - 이슈 #60(M84-17): BR-S3-05·REQ-FN-3-04는 "pH 추가·삭제 가능"을 이미 규정하는데
  // 추가만 구현돼 있었다(결함). 삭제도 격자 조작이므로 잠금(BR-LOT-10)을 그대로 탄다.
  // 최소 1개는 남긴다 — 전부 지우면 f2 기준 자체가 사라지고 빈 표만 남는다.

  const removePhColumn = (phIdx: number) => {
    const cur = expRef.current.lots[expRef.current.active_lot]
    const list = cur?.ph_profiles || []
    if (list.length <= 1) return // 최소 1개 용액 유지
    const name = list[phIdx]?.ph?.trim() || `${phIdx + 1}번째`
    if (!window.confirm(`${name} 용액 열을 삭제하시겠습니까?\n이 용액의 측정값(avg·SD)이 함께 삭제됩니다.`)) return
    patchLot((l) => ({ ...l, ph_profiles: l.ph_profiles.filter((_, i) => i !== phIdx) }))
  }

  const removeTimePoint = (tpIdx: number) => {
    const cur = expRef.current.lots[expRef.current.active_lot]
    const tps = cur?.ph_profiles?.[0]?.time_points || []
    if (tps.length <= 1) return // 최소 1개 시점 유지
    if (!window.confirm(`${tps[tpIdx]?.time ?? ''}분 시점을 삭제하시겠습니까?\n모든 용액에서 이 행이 삭제됩니다.`)) return
    patchLot((l) => ({
      ...l,
      ph_profiles: l.ph_profiles.map((p) => ({
        ...p,
        time_points: (p.time_points || []).filter((_, i) => i !== tpIdx),
      })),
    }))
  }

  const updatePhLabel = (phIdx: number, val: string) => {
    patchLot((l) => ({ ...l, ph_profiles: l.ph_profiles.map((p, i) => (i === phIdx ? { ...p, ph: val } : p)) }))
  }

  const updateCell = (phIdx: number, tpIdx: number, field: keyof DissolutionTimePoint, val: number) =>
    patchLot((l) => ({
      ...l,
      ph_profiles: l.ph_profiles.map((p, pi) =>
        pi === phIdx
          ? { ...p, time_points: p.time_points.map((tp, ti) => (ti === tpIdx ? { ...tp, [field]: val } : tp)) }
          : p,
      ),
    }))

  const updateTime = (tpIdx: number, val: number) => {
    patchLot((l) => ({
      ...l,
      ph_profiles: l.ph_profiles.map((p) => ({
        ...p,
        time_points: (p.time_points || []).map((tp, ti) => (ti === tpIdx ? { ...tp, time: val } : tp)),
      })),
    }))
  }

  const profiles = lot?.ph_profiles || []
  const timePoints = profiles[0]?.time_points || []
  // 0 시점 숨김(M84-16) — 단, **전 행이 0인 격자는 숨기지 않는다.** 그런 데이터는 0분
  // 측정이 아니라 시점이 안 잡힌 **빈 골격**이라(구 `+ Time Point` 가 0으로 붙이던 자리)
  // 감추면 표가 통째로 비어 손댈 길이 없어진다.
  const hideZero = timePoints.some((tp) => tp?.time !== 0)

  // ── 붙여넣기(M84-72, 3곳째) ─────────────────────────────────────────
  // 앵커 좌표계는 **표에 보이는 행 서수**다(숨긴 0 시점은 세지 않는다). 원 인덱스(idx)를
  // 함께 들고 다녀야 수정·삭제가 올바른 행에 꽂힌다 — `COMP-DISSOLUTION-GRID` 와 같은 형태.
  const visibleRows = useMemo(
    () => timePoints
      .map((tp, idx) => ({ time: tp?.time ?? 0, idx }))
      .filter((r) => !(hideZero && r.time === 0)),
    [timePoints, hideZero],
  )

  // 열 좌표 = `용액 인덱스 × 2 + (SD 면 1)`. 시점 열은 붙여넣기 대상이 아니다.
  const colCount = profiles.length * 2

  const handlePaste = (e: ClipboardEvent<HTMLInputElement>, rowOrd: number, colIdx: number) => {
    const text = e.clipboardData.getData('text/plain')
    // 단일 셀은 가로채지 않는다 — 평범한 한 칸 붙여넣기의 기본 동작을 남긴다(규약 ③).
    if (!isRangePaste(text)) return
    e.preventDefault()

    let matrix = stripHeaderRows(parseClipboardMatrix(text))
    // 시점 열까지 함께 복사해 오는 일이 흔하다. 값이 **정확히 일치할 때만** 그 열을 버린다.
    if (colIdx === 0) {
      matrix = dropIndexColumn(matrix, visibleRows.slice(rowOrd).map((r) => r.time))
    }

    // 셀마다 `patchLot` 을 부르면 `commit`·`schedulePersist` 가 N회 돈다. 복사본에 모두
    // 채운 뒤 **한 번**에 넣는다. 숨긴 0 행은 `visibleRows[r].idx` 매핑을 거치므로 닿지 않는다.
    const cur = expRef.current.lots[expRef.current.active_lot]
    if (!cur) return
    const nextProfiles = cur.ph_profiles.map((p) => ({
      ...p,
      time_points: (p.time_points || []).map((tp) => ({ ...tp })),
    }))
    const res = applyMatrix({
      matrix, anchorRow: rowOrd, anchorCol: colIdx,
      rowCount: visibleRows.length, colCount,
      write: (r, c, value) => {
        const target = nextProfiles[Math.floor(c / 2)]?.time_points[visibleRows[r].idx]
        if (!target) return
        if (c % 2 === 0) target.dissolution = value
        else target.sd = value
      },
    })

    if (res.filled > 0) patchLot((l) => ({ ...l, ph_profiles: nextProfiles }))
    setPasteNote(describePaste(res))
  }

  const saveLabel: Record<SaveState, string> = {
    idle: '',
    saving: '저장 중…',
    saved: '저장됨',
    error: '저장 실패 — 다시 시도하십시오',
    held: '미저장 — 주성분 확정 후 저장됩니다',
  }

  return (
    <div className="mb-4">
      <h4 className="mb-2 text-xs font-semibold uppercase tracking-wider text-text-secondary">
        Reference Drug Dissolution &mdash; Direct Entry
      </h4>

      {/* COMP-LOT-TABS — 탭 = "Lot N · MM/DD"(BR-LOT-12). 클릭 = 활성 전환, × = 숨기기. */}
      <div className="mb-2 flex flex-wrap items-center gap-1.5">
        {exp.lots.map((l, i) => (
          <span key={l.id ?? `local-${i}`} className="inline-flex items-center">
            <button
              onClick={() => void selectLot(i)}
              className="inline-flex items-center gap-1.5 rounded-l px-2.5 py-1 text-[11px] font-medium transition-colors"
              style={
                i === active
                  ? { background: 'var(--btn-accent-purple)', color: '#1a1b1e' }
                  : { background: 'var(--bg-input)', color: 'var(--color-text-secondary)' }
              }
              title={i === active ? '진행 중 lot' : 'lot 선택'}
            >
              <span>{lotDisplayName(l.lot_no, l.no ?? i + 1)}</span>
              {l.test_date ? <span style={{ opacity: 0.75 }}>· {fmtMMDD(l.test_date)}</span> : null}
            </button>
            <button
              onClick={() => void removeLot(i)}
              disabled={exp.lots.length <= 1 || !canWrite}
              className="rounded-r px-1.5 py-1 text-[11px] leading-none transition-opacity hover:opacity-100 disabled:opacity-30"
              style={{
                background: i === active ? 'var(--btn-accent-purple)' : 'var(--bg-input)',
                color: i === active ? '#1a1b1e' : 'var(--color-text-secondary)',
                opacity: 0.7,
              }}
              title={canWrite ? '숨기기(soft delete)' : READ_ONLY_TITLE}
              aria-label={`${lotDisplayName(l.lot_no, l.no ?? i + 1)} 숨기기`}
            >
              ✕
            </button>
          </span>
        ))}
        <button
          onClick={() => void addLot()}
          disabled={!canWrite}
          title={canWrite ? undefined : READ_ONLY_TITLE}
          className="rounded px-2 py-1 text-[11px] text-text-secondary hover:bg-bg-input disabled:opacity-40"
          style={{ border: '1px solid var(--border-soft)' }}
        >
          + New Lot
        </button>
        <span className="ml-auto text-[10px] text-text-muted">{saveLabel[saveState]}</span>
      </div>

      {/* viewer(#114) — Lot 표기·측정일·격자·값 편집을 한 겹으로 잠근다(탭 전환은 위에서 열어 둔다). */}
      <fieldset
        disabled={!canWrite}
        title={canWrite ? undefined : READ_ONLY_TITLE}
        className="m-0 min-w-0 rounded border p-3"
        style={{ borderColor: 'var(--border-subtle)' }}
      >

        <div className="mb-3 flex flex-wrap items-center gap-3">
          <label className="text-[11px] text-text-secondary">Lot:</label>
          <input
            type="text"
            value={lot?.lot_no ?? ''}
            onChange={(e) => updateMeta('lot_no', e.target.value)}
            className="w-28 rounded bg-bg-input px-2 py-1 text-[11px] text-text-body outline-none"
            style={{ border: '1px solid var(--border-soft)' }}
          />
          <label className="text-[11px] text-text-secondary">Date:</label>
          <input
            type="date"
            value={lot?.test_date ?? ''}
            onChange={(e) => updateMeta('test_date', e.target.value)}
            className="rounded bg-bg-input px-2 py-1 text-[11px] text-text-body outline-none"
            style={{ border: '1px solid var(--border-soft)' }}
          />
          <div className="ml-auto flex gap-2">
            <button
              onClick={addTimePoint}
              className="rounded px-2 py-1 text-[10px] text-text-secondary hover:bg-bg-input disabled:opacity-40"
              style={{ border: '1px solid var(--border-soft)' }}
            >
              + Time Point
            </button>
            <button
              onClick={addPhColumn}
              className="rounded px-2 py-1 text-[10px] text-text-secondary hover:bg-bg-input disabled:opacity-40"
              style={{ border: '1px solid var(--border-soft)' }}
            >
              + pH Column
            </button>
          </div>
        </div>

        {/* 빈 상태 안내 — 표가 헤더만 남아 "왜 아무것도 없지"로 읽히던 자리(260721). */}
        {profiles.length === 0 && (
          <p className="mb-2 text-[11px] text-warn">
            이 Lot에는 대조약 용출 프로파일이 아직 입력되지 않았습니다. <b>+ pH Column</b>으로
            용액을 추가하고 <b>+ Time Point</b>로 측정 시점을 늘리십시오. 이 값이 f2 계산의
            기준이 되며, 입력 전에는 시험 배치 f2가 산출되지 않습니다.
          </p>
        )}
        {/* 0 시점은 표에서 감춘다(M84-16) — 값이 있는데 행이 없어 보이면 오해가 난다. */}
        {hideZero && timePoints.some((tp) => tp?.time === 0) && (
          <p className="mb-2 text-[10px] text-text-muted" data-testid="rld-zero-note">
            0분 시점은 입력이 불요해 표에서 감췄습니다 — 그래프에는 그대로 나오고 f2 계산에서는 제외됩니다(ADR-0005).
          </p>
        )}

        {/* M84-72 — 붙여넣기가 주 입력 경로임을 표에서 알린다(용출 그리드와 같은 문구). */}
        {profiles.length > 0 && (
          <p
            className="mb-2 text-[10px] text-text-muted"
            title="엑셀에서 범위를 복사해 avg·SD 칸 아무 곳에나 붙여넣으면 그 칸부터 행×열 그대로 채워집니다. 시점(Time) 열을 함께 복사해도 자동으로 맞춰지고, 빈 칸과 숫자가 아닌 칸은 건너뜁니다."
            data-testid="rld-paste-hint"
          >
            ⌘/Ctrl+V 붙여넣기 가능 — 엑셀 범위를 복사해 avg·SD 칸에 붙여넣으십시오.
          </p>
        )}

        <div className="overflow-x-auto">
          <table className="text-[11px]">
            <thead>
              <tr style={{ backgroundColor: 'var(--color-bg-panel)' }}>
                <th className="px-2 py-1.5 text-center font-medium text-text-secondary whitespace-nowrap">Time (min)</th>
                {profiles.map((p, pi) => (
                  <th key={pi} colSpan={2} className="px-2 py-1.5 text-center font-medium text-text-secondary">
                    <span className="inline-flex items-center gap-1">
                      <input
                        type="text"
                        value={p.ph}
                        onChange={(e) => updatePhLabel(pi, e.target.value)}
                        className="w-20 rounded bg-bg-input px-1 py-0.5 text-center text-[11px] text-text-body outline-none disabled:opacity-50"
                        placeholder="pH X.X"
                      />
                      {/* 용액 열 삭제(M84-17) — 격자 조작이라 잠금을 탄다. 최소 1개는 남긴다. */}
                      <button
                        onClick={() => removePhColumn(pi)}
                        disabled={profiles.length <= 1}
                        className="rounded px-1 py-0.5 text-[11px] leading-none text-text-muted transition-opacity hover:bg-bg-input disabled:opacity-25"
                        title={
                          profiles.length <= 1
                              ? '최소 1개 용액은 유지해야 합니다'
                              : '이 용액 열 삭제'
                        }
                        aria-label={`${p.ph || `${pi + 1}번째`} 용액 열 삭제`}
                      >
                        ✕
                      </button>
                    </span>
                  </th>
                ))}
              </tr>
              <tr style={{ backgroundColor: 'var(--color-bg-panel)' }}>
                <th />
                {profiles.map((_, pi) => (
                  <React.Fragment key={pi}>
                    <th className="px-2 py-1 text-center text-[10px] text-text-muted">avg</th>
                    <th className="px-2 py-1 text-center text-[10px] text-text-muted">SD</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            <tbody>
              {/* 0 시점은 표에서 숨긴다(M84-16). 수정·삭제가 인덱스 기준이라
                  **원 인덱스(tpIdx)를 유지한 채** 건너뛴다. 데이터는 그대로 남는다.
                  붙여넣기 앵커는 **보이는 행 서수(rowOrd)** 라 둘을 함께 들고 다닌다(M84-72). */}
              {visibleRows.map(({ idx: tpIdx }, rowOrd) => (
                <tr key={tpIdx} className="border-t" style={{ borderColor: 'var(--border-subtle)' }}>
                  <td className="px-1 py-1">
                    <span className="inline-flex items-center gap-1">
                      <input
                        type="number"
                        value={timePoints[tpIdx]?.time ?? 0}
                        onChange={(e) => updateTime(tpIdx, Number(e.target.value))}
                        className="w-14 rounded bg-bg-input px-1 py-0.5 text-center text-[11px] text-text-body outline-none disabled:opacity-50"
                      />
                      {/* 시점 행 삭제(M84-17) — 모든 용액에서 같은 인덱스를 지워 격자를 직사각으로 유지. */}
                      <button
                        onClick={() => removeTimePoint(tpIdx)}
                        disabled={timePoints.length <= 1}
                        className="rounded px-1 py-0.5 text-[11px] leading-none text-text-muted transition-opacity hover:bg-bg-input disabled:opacity-25"
                        title={
                          timePoints.length <= 1
                              ? '최소 1개 시점은 유지해야 합니다'
                              : '이 시점 행 삭제'
                        }
                        aria-label={`${timePoints[tpIdx]?.time ?? ''}분 시점 삭제`}
                      >
                        ✕
                      </button>
                    </span>
                  </td>
                  {profiles.map((p, pi) => (
                    <React.Fragment key={pi}>
                      {/* 값(avg·SD)은 잠금과 무관하게 편집 가능(BR-LOT-10 완화) */}
                      <td className="px-1 py-1">
                        <input
                          type="number"
                          value={p.time_points[tpIdx]?.dissolution ?? 0}
                          onChange={(e) => updateCell(pi, tpIdx, 'dissolution', Number(e.target.value))}
                          onPaste={(e) => handlePaste(e, rowOrd, pi * 2)}
                          className="w-14 rounded bg-bg-input px-1 py-0.5 text-center text-[11px] text-text-body outline-none"
                          data-testid={`rld-avg-${pi}-${timePoints[tpIdx]?.time ?? 0}`}
                        />
                      </td>
                      <td className="px-1 py-1">
                        <input
                          type="number"
                          value={p.time_points[tpIdx]?.sd ?? 0}
                          onChange={(e) => updateCell(pi, tpIdx, 'sd', Number(e.target.value))}
                          onPaste={(e) => handlePaste(e, rowOrd, pi * 2 + 1)}
                          className="w-14 rounded bg-bg-input px-1 py-0.5 text-center text-[11px] text-text-body outline-none"
                          step={0.1}
                          data-testid={`rld-sd-${pi}-${timePoints[tpIdx]?.time ?? 0}`}
                        />
                      </td>
                    </React.Fragment>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {pasteNote && (
          <p className="mt-1.5 text-[10px] text-accent-teal" data-testid="rld-paste-note">
            {pasteNote}
          </p>
        )}
        {profiles.length === 0 && (
          <p className="py-3 text-center text-[11px] text-text-secondary">Click "+ pH Column" to add dissolution media.</p>
        )}
      </fieldset>

    </div>
  )
}
